export default {"src":"/_next/static/media/instagramSm.dd241f69.svg","height":26,"width":25};